import { FormSchemaType } from './HakajimaiRequest'

export const dataConvertFunction = (formValue: FormSchemaType) => {
  return {
    customer: {
      ...formValue,
      hakajimai_prefecture_ids: [formValue.hakajimai_prefecture_ids]
    }
  }
}
